import { Pipe, PipeTransform } from '@angular/core';
import { Contract } from "../../classes/contract";

@Pipe({
  name: 'contractCodeFilter',
  pure: false
})
export class ContractCodeFilterPipe implements PipeTransform {

  transform(contractList: Array<Contract>, filterValue: string): any {
    if (!contractList || !filterValue) {
      return contractList;
    }
    return contractList.filter(contract => contract.code.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
